import { useEffect } from 'react';

const useBeforeUnload = (callback, enabled = true) => {
  useEffect(() => {
    if (!enabled) return () => {};

    const handleBeforeUnload = () => {
      callback();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [callback, enabled]);
};

export default useBeforeUnload;
